document.addEventListener("DOMContentLoaded", function () {
  const homeDropdown = document.getElementById("home-dropdown");

  if (homeDropdown) {
    function closeAllDetails() {
      const openDetails = homeDropdown.querySelectorAll("details[open]");
      openDetails.forEach(detail => detail.removeAttribute("open"));
    }

    document.addEventListener("click", function (event) {
      if (!homeDropdown.contains(event.target)) {
        closeAllDetails();
      }
    });

    homeDropdown.addEventListener("click", function (event) {
      if (event.target.tagName.toLowerCase() === "summary") {
        event.stopPropagation();
      }
    });
  }

  var links = document.links;
  for (let i = 0; i < links.length; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = "_blank";
      links[i].rel = "noreferrer noopener";
    }
  }

  if (typeof jQuery !== "undefined") {
    var $ = jQuery;

    if ($(".abz_product_ul").length && $.fn.slick) {
      $(".abz_product_ul").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        vertical: true,
        verticalSwiping: true,
        initialSlide: 0,
        autoplay: true,
        autoplaySpeed: 3000,
        pauseOnHover: true,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              vertical: false,
              verticalSwiping: false
            }
          }
        ]
      });
    }

    $(".tab-content").hide();
    $('.tab-content[data-tab="1"]').show();
    $('.abz_select span[value="1"]').addClass("active");

    $(".abz_select span").on("click", function () {
      $(".abz_select span").removeClass("active");
      $(this).addClass("active");

      $(".tab-content").hide();

      var tabId = $(this).attr("value");
      $('.tab-content[data-tab="' + tabId + '"]').show();
    });

    $(".open").on("click", function () {
      $(".pop-outer").fadeIn("slow");
    });

    $(".close").on("click", function () {
      $(".pop-outer").fadeOut("slow");
    });

    $(".open-new").on("click", function () {
      $(".pop-outer-new").fadeIn("slow");
    });

    $(".close-new").on("click", function () {
      $(".pop-outer-new").fadeOut("slow");
    });

    $(".pop-pdp.open, .pop-pdp.open-new").on("click", function () {
      $("body").addClass("custom-class");
    });

    $(".pop-pdp.close, .pop-pdp.close-new").on("click", function () {
      $("body").removeClass("custom-class");
    });

    var $slider = $(".collection-page-list-product");

    if ($slider.length && $.fn.slick) {
      var itemCount = $slider.children().length;
      var windowWidth = $(window).width();

      if (windowWidth >= 750 && itemCount >= 4) {
        if (!$slider.hasClass("slick-initialized")) {
          $slider.slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
            autoplay: true,
            autoplaySpeed: 3000
          });
        }
      } else if (windowWidth <= 749) {
        if (!$slider.hasClass("slick-initialized")) {
          $slider.slick({
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
            autoplay: true,
            autoplaySpeed: 3000
          });
        }
      }
    }
  }

  if (window.matchMedia("(max-width: 749px)").matches) {
    document.querySelectorAll(".footer-title-abz").forEach((heading, index) => {
      const nextBlock = heading.nextElementSibling;
      if (!nextBlock) return;

      heading.classList.add("block-collapsed");
      heading.setAttribute("role", "button");
      heading.setAttribute("aria-expanded", "false");
      heading.setAttribute("tabindex", "0");

      nextBlock.setAttribute("id", `footer-block-index-${index}`);
      heading.setAttribute("aria-controls", `footer-block-index-${index}`);

      const handleCollapse = () => {
        const isCollapsed = heading.classList.contains("block-collapsed");
        heading.classList.toggle("block-collapsed", !isCollapsed);
        heading.setAttribute("aria-expanded", isCollapsed ? "true" : "false");
      };

      heading.addEventListener("click", handleCollapse);
      heading.addEventListener("keypress", handleCollapse);
    });
  }
});